import type { Component } from 'vue';
import {
  AlarmClock,
  Avatar,
  Bell,
  Box,
  ChatDotRound,
  Collection,
  Cpu,
  DataAnalysis,
  Document,
  Files,
  Goods,
  Headset,
  Key,
  Lock,
  Management,
  Memo,
  Menu,
  Microphone,
  Monitor,
  Operation,
  Reading,
  Notebook,
  Setting,
  ShoppingCart,
  Star,
  Tickets,
  Tools,
  UploadFilled,
  User,
  UserFilled,
} from '@element-plus/icons-vue';

export interface AdminMenuIconOption {
  name: string;
  label: string;
  component: Component;
}

export const ADMIN_MENU_ICON_OPTIONS: AdminMenuIconOption[] = [
  { name: 'DataAnalysis', label: '数据看板', component: DataAnalysis },
  { name: 'Operation', label: '业务运营', component: Operation },
  { name: 'Cpu', label: '设备资源', component: Cpu },
  { name: 'Collection', label: '内容集合', component: Collection },
  { name: 'Setting', label: '系统设置', component: Setting },
  { name: 'User', label: '用户', component: User },
  { name: 'UserFilled', label: '用户管理', component: UserFilled },
  { name: 'Avatar', label: '角色账户', component: Avatar },
  { name: 'Key', label: '权限密钥', component: Key },
  { name: 'Lock', label: '安全权限', component: Lock },
  { name: 'Menu', label: '菜单', component: Menu },
  { name: 'Management', label: '管理', component: Management },
  { name: 'Monitor', label: '监控', component: Monitor },
  { name: 'Document', label: '文档', component: Document },
  { name: 'Files', label: '文件', component: Files },
  { name: 'Memo', label: '记录', component: Memo },
  { name: 'Tickets', label: '订单票据', component: Tickets },
  { name: 'ShoppingCart', label: '订单购物车', component: ShoppingCart },
  { name: 'Goods', label: '商品', component: Goods },
  { name: 'Box', label: '资源包', component: Box },
  { name: 'UploadFilled', label: '上传发布', component: UploadFilled },
  { name: 'Bell', label: '通知提醒', component: Bell },
  { name: 'AlarmClock', label: '定时提醒', component: AlarmClock },
  { name: 'Star', label: '星级任务', component: Star },
  { name: 'Microphone', label: '语音', component: Microphone },
  { name: 'Headset', label: '声音服务', component: Headset },
  { name: 'ChatDotRound', label: '会话消息', component: ChatDotRound },
  { name: 'Reading', label: '故事阅读', component: Reading },
  { name: 'Notebook', label: '诗词簿册', component: Notebook },
  { name: 'Tools', label: '工具维护', component: Tools },
];

const iconRegistry = new Map(ADMIN_MENU_ICON_OPTIONS.map(option => [option.name, option.component]));

export function resolveAdminMenuIcon(name?: string | null) {
  return name ? iconRegistry.get(name.trim()) : undefined;
}

export function isSupportedAdminMenuIcon(name?: string | null) {
  return !name || Boolean(resolveAdminMenuIcon(name));
}
